import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';
import getCachedResultTemplatesByTypes from './getCachedResultTemplatesByTypes';
import handleIndexIncrementation from './handleIndexIncrementation';
import handleInputFocus from './handleInputFocus';
import handleInputReset from './handleInputReset';
import handlePagination from './handlePagination';
import handleSearch from './handleSearch';
import handleSuggestions from './handleSuggestions';
import handleSuggestionSelect from './handleSuggestionSelect';
import handleTypeSelect from './handleTypeSelect';

/**
 * Attach interactions to every element that matches selector.
 */
$('.search').each((_, component) => {
    const types = ['product', 'reference', 'topic', 'download'];
    $(component).data('types', types);
    $(component).data('typeIndex', 0); // set initial type index to 0
    $(component).data('resultsByType', {}); // will be filled by search handler
    const suggestionsDelay = Number($(component).attr('data-suggestions-delay') || 0);
    const searchDelay = Number($(component).attr('data-search-delay') || 0);
    const $suggestionTemplate = $(component).find('[data-suggestion-template]')
        .removeAttr('data-suggestion-template')
        .detach();
    const typeTemplates = getCachedResultTemplatesByTypes(component, types);

    $(component)
        .on('search:show', handleInputReset(component))
        .on('search:show', handleInputFocus(component))
        .on('search:show', handleSuggestions(component, $suggestionTemplate))
        .on('input', '.search__input', throttle(
            handleSuggestions(component, $suggestionTemplate),
            suggestionsDelay,
            { leading: false }
        ))
        .on('input', '.search__input', debounce(
            handleSearch(component, typeTemplates),
            searchDelay
        ))
        .on('click', '.search__suggestions__item', handleSuggestionSelect(component))
        .on('tabs:select', '.tabs', handleTypeSelect(component))
        .on('tabs:select', '.tabs', handlePagination(component, typeTemplates))
        .on('click', '.loader', handleIndexIncrementation(component))
        .on('click', '.loader', handlePagination(component, typeTemplates))
        .on('submit', '.search__form', handleSearch(component, typeTemplates));

    $(window)
        .on('load', handleSuggestions(component, $suggestionTemplate))
        .on('load', handleSearch(component, typeTemplates));
});



// WEBPACK FOOTER //
// ./src/scripts/components/search/index.js